/*const firstSelect = document.querySelector('.single-option-selector');
const secondSelect = document.querySelector('select[name="id"]');
if(firstSelect){ 
firstSelect.addEventListener('change', function() {
  const selectedOption = this.value; 
  for (let option of secondSelect.options) {
    if (option.textContent.trim() === selectedOption) {
      var variantInput = option.value;
      loadHwsPlans(variantInput);
      break;
    } 
  } 
  console.log(secondSelect.value);
});
}*/ 


document.body.addEventListener('change', function(event) {
  if (event.target && event.target.id === 'variantSelect') {
    var variantSelect = event.target;
    if (variantSelect && variantSelect.options.length > 0) {
      var value = variantSelect.value;
    
      loadHwsPlans(value);
    }
  }
});
document.addEventListener('DOMContentLoaded', async () => {
    var variantInput = await getVariantParamValue();
    console.log(variantInput);
    loadHwsPlans(variantInput);
});
document.addEventListener('DOMContentLoaded', async () => {
    const variantInput = await getVariantParamValue();
  setTimeout(function() {
  
  const hiddenSelect = document.querySelector('#hidden-variant-select');
  if (!hiddenSelect) return;
  const matchedHiddenOption = Array.from(hiddenSelect.options).find(
    opt => opt.dataset.id === String(variantInput)
  );
  if (!matchedHiddenOption) {
    console.log('❌ No matching variant found in hidden select');
    return;
  }
  const isAvailable = String(matchedHiddenOption.dataset.available) === 'true';
  const checkoutText = document.querySelector('.hwsubsCheckouttext');
  const checkoutBtn = document.querySelector('#hwsubsCheckout');
  const subsPrice = document.querySelector('#Hw-GetSubsPrice');
  if (!isAvailable) {
    console.log(isAvailable ? 'Available ✅' : 'Sold Out ❌');
    if (checkoutText) checkoutText.textContent = 'Sold Out';
    if (checkoutBtn) checkoutBtn.disabled = true;
    if (subsPrice) subsPrice.style.display = 'none';
  }
  }, 500);
});
async function getVariantParamValue() { 
  const url = new URL(window.location.href);
 
  // ✅ Case 1: Variant exists in query param
  if (url.searchParams.has('variant')) {
    return url.searchParams.get('variant');
  }

  // ✅ Case 2: No variant → fetch product JSON by handle
  try {
    // Extract handle from URL (/products/handle)
    let pathParts = window.location.pathname.split("/");
    let handleIndex = pathParts.indexOf("products");
    if (handleIndex === -1 || !pathParts[handleIndex + 1]) return null;

    let productHandle = pathParts[handleIndex + 1];

    let res = await fetch(`/products/${productHandle}.js`);
  console.log(res);
    if (!res.ok) throw new Error("Product fetch failed");

    let product = await res.json();
    if (product.variants && product.variants.length > 0) {
      return product.variants[0].id; // 👈 First variant ID
    }
  } catch (err) {
    console.error("Error fetching first variant:", err);
  }

  return null;
}


/* =========================
   ✅ MINI CART UPDATE FUNCTION
=========================*/
function doUpdateDropdownCartCustom(n) {

    var itemHTML = '<li class="item" id="cart-item-{ID}">\
    <a href="{URL}" class="product-image">\
    <img src="{IMAGE}" alt="{TITLE}"></a>\
    <div class="product-details">\
    <a href="javascript:void(0)" class="btn-remove"><span class="mdi mdi-close"></span></a>\
    <p class="product-name"><a href="{URL}">{TITLE}</a></p>\
    <div class="cart-collateral">\
    <span class="price">{PRICE}</span> x {QUANTITY}\
    </div></div></li>';

    /* =========================
       ✅ UPDATE COUNT
    ==========================*/
    document.querySelectorAll("#CartCount_ .cart-products-count, #CartCount_sticky .cart-products-count")
    .forEach(el => el.textContent = n.item_count);

    /* =========================
       ✅ UPDATE TOTAL
    ==========================*/
    var total = Shopify.formatMoney(n.total_price, window.money_format);

    document.querySelectorAll("#minicart_total span.money, #slidedown-cart .summary .price, #Sticky-slidedown-cart .summary .price")
    .forEach(el => el.innerHTML = total);

    /* =========================
       ✅ CONTAINERS
    ==========================*/
    const containers = [
        "#slidedown-cart .mini-products-list",
        "#Sticky-slidedown-cart .mini-products-list"
    ];

    /* =========================
       ✅ CLEAR OLD ITEMS
    ==========================*/
    containers.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) el.innerHTML = "";
    });

    /* =========================
       ✅ ADD ITEMS
    ==========================*/
    if (n.item_count > 0) {

        n.items.forEach(function(item) {

            var html = itemHTML
                .replace(/\{ID\}/g, item.key)
                .replace(/\{URL\}/g, item.url)
                .replace(/\{TITLE\}/g, item.product_title)
                .replace(/\{QUANTITY\}/g, item.quantity)
                .replace(/\{IMAGE\}/g, Shopify.resizeImage(item.image, "medium"))
                .replace(/\{PRICE\}/g, Shopify.formatMoney(item.price, window.money_format));

            containers.forEach(selector => {
                const el = document.querySelector(selector);
                if (el) {
                    el.insertAdjacentHTML("beforeend", html);
                    el.style.display = "block"; // 🔥 ensure visible
                }
            });

        });

        /* =========================
           ✅ REMOVE ITEM
        ==========================*/
        document.querySelectorAll(".btn-remove").forEach(btn => {

            btn.onclick = function(e) {
                e.preventDefault();

                var id = this.closest(".item").id.replace("cart-item-", "");

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: id,
                        quantity: 0
                    })
                })
                .then(res => res.json())
                .then(cart => {
                    doUpdateDropdownCartCustom(cart);
                });

            };

        });

    }

    /* =========================
       ✅ EMPTY CART FIX
    ==========================*/
    const emptySelectors = [
        '.cart-empty',
        '.empty-cart',
        '.mini-cart-empty',
        '.no-items'
    ];

    emptySelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            el.style.display = n.item_count > 0 ? "none" : "block";
        });
    });

    /* =========================
       ✅ SHOW / HIDE LIST
    ==========================*/
    containers.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
            el.style.display = n.item_count > 0 ? "block" : "none";
        }
    });

    /* =========================
       ✅ HAS ITEMS FIX (MAIN FINAL FIX)
    ==========================*/
    const hasItemsSelectors = [
        '.has-items',
        '.mini-cart.has-items',
        '#slidedown-cart .has-items',
        '#Sticky-slidedown-cart .has-items'
    ];

    hasItemsSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            el.style.display = n.item_count > 0 ? "block" : "none";
        });
    });

    /* =========================
       ✅ FORCE HIDE EMPTY WRAPPER
    ==========================*/
    const emptyWrappers = [
        '.no-items',
        '.cart-empty',
        '.empty-cart'
    ];

    emptyWrappers.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
            if (n.item_count > 0) {
                el.style.display = "none";
            }
        });
    });
}

var domainName = Shopify.shop;
var productId = '';
var productIdElement = document.querySelector('input[name="product-id"]');
if (productIdElement) {
  productId = productIdElement.value;
}

var scriptTag1 = document.getElementById('shopify-features');
if (scriptTag1) {
  var shopifyFeatures = JSON.parse(scriptTag1.textContent);
  //domainName = shopifyFeatures.domain;
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".quick_shop").forEach(button => {
        button.addEventListener("click", function () {
            let quickproductId = this.getAttribute("data-id");
            let quickdomainName = Shopify.shop;
          console.log(quickproductId);
          console.log(quickdomainName);
            QuickloadHwsPlans(quickproductId, quickdomainName);
        });
    });
});

    function QuickloadHwsPlans(quickproductId,quickdomainName){
    
      if(quickdomainName != "" && quickproductId != ""){
       
        var data = {
            myshopifyDomain: btoa(quickdomainName),
            product: btoa(quickproductId)
          };
        var jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: jsonString,
          redirect: "follow"
        };

  
        fetch(`https://subscriptions.gosimple.app/api/plans`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
              if (result.returnhtml) {
                if(result.returnhtml != ''){
                  var forms = document.querySelectorAll('form[action="/cart/add"]');
                  forms.forEach(function(form) {
                    form.style.display = 'none';
                  });
                }

                
          
                var productprice = document.querySelector('.price');
                if (productprice) {
                  productprice.style.display = 'none';
                }
          
                var variantSelects = document.querySelector('variant-selects');
                if (variantSelects) {
                  variantSelects.style.display = 'none';
                }
          
                var quantityInput = document.querySelector('quantity-input');
                if (quantityInput) {
                  quantityInput.style.display = 'none';
                  var closestLabel = quantityInput.previousElementSibling;
                  if (closestLabel && closestLabel.tagName.toLowerCase() === 'label') {
                    closestLabel.style.display = 'none';
                  }
                }
          
                let hwsInsertDiv = document.querySelector('#Hwsinsertlists');
                if (hwsInsertDiv) {
                  hwsInsertDiv.innerHTML = result.returnhtml;
                  appendAjaxResponseToDOM1(result.paystrackjs);
                }

                document.querySelectorAll(".batchblocks").forEach(el => {
                                el.style.display = "block";
                            });
    
              }
          })
          .catch((error) => {
              console.error("Error:", error);
          });

      }
    }

    function getAssetUrl(fileName) {
        if (!window.hwsAssetDummy) {
            throw new Error("hwsAssetDummy not defined. Add it in theme.liquid.");
        }
        return window.hwsAssetDummy.replace("dummy.json", fileName);
    } 

    function loadHwsPlans(variantInput, qty = null, postselctedtype = null) {
        if (!productId) {
            let quickshopInput = document.querySelector("#quickshop input[name='product-id']");
            if (quickshopInput) {
            productId = quickshopInput.value; // Get product ID from input field
            }
        }

        if (domainName !== "" && productId !== "") {
            let fileName = productId;
            if (variantInput) {
            fileName += "_" + variantInput;
            }
            fileName += ".json";

            let fileUrl = getAssetUrl(fileName);
            console.log("Fetching:", fileUrl);

            fetch(fileUrl)
            .then((response) => {
                if (!response.ok) {
                throw new Error("Asset not found: " + fileUrl);
                }
                return response.json();
            })
            .then((result) => {
                if (result.returnhtml) {
                  if(result.returnhtml != ''){
                    var forms = document.querySelectorAll('form[action="/cart/add"]');
                    forms.forEach(function(form) {
                      form.style.display = 'none';
                    });
                  }
                  
                  var productprice = document.querySelector('.price');
                  if (productprice) {
                    productprice.style.display = 'none';
                  }
            
                  var variantSelects = document.querySelector('variant-selects');
                  if (variantSelects) {
                    variantSelects.style.display = 'none';
                  }

                  var variantSelectssingle__price = document.querySelector('.product-single__price');
                  if (variantSelectssingle__price) {
                    variantSelectssingle__price.style.display = 'none';
                  }
            
                  var quantityInput = document.querySelector('quantity-input');
                  if (quantityInput) {
                    quantityInput.style.display = 'none';
                    var closestLabel = quantityInput.previousElementSibling;
                    if (closestLabel && closestLabel.tagName.toLowerCase() === 'label') {
                      closestLabel.style.display = 'none';
                    }
                  }
                  if(postselctedtype){
                    if(postselctedtype == 'onetime'){
                        setTimeout(function() {
                          let defaultClickElement = document.querySelector(".clickbyonetime");
                          if (defaultClickElement) {
                            defaultClickElement.click();
                          }
                                      document.querySelectorAll(".batchblocks").forEach(el => {
                                          el.style.display = "block";
                                      });
                        }, 300);
                    }else{
                        setTimeout(function() {
                          let defaultClickElement = document.querySelector(".clickbydefault");
                          if (defaultClickElement) {
                            defaultClickElement.click();
                          }
                                      document.querySelectorAll(".batchblocks").forEach(el => {
                                          el.style.display = "block";
                                      });
                        }, 300);
                    }
                  }else{
                    setTimeout(function() {
                          let defaultClickElement = document.querySelector(".clickbydefault");
                          if (defaultClickElement) {
                              defaultClickElement.click();
                          }
                          document.querySelectorAll(".batchblocks").forEach(el => {
                              el.style.display = "block";
                          });
                      }, 300);
                  }
                  
                  
                  let hwsInsertDiv = document.querySelector('#Hwsinsertlists');
                  if (hwsInsertDiv) {
                    hwsInsertDiv.innerHTML = result.returnhtml;
                    appendAjaxResponseToDOM1(result.paystrackjs);
                  }
                  if(qty){
                    let inputField = document.querySelector(".Hw-subs-qty-input");
                    if(inputField){
                        inputField.value = qty;
                    }
                  }
                  initSubscriptionJS();
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        }
    }

    /*function loadHwsPlans(variantInput, qty = null, postselctedtype = null){

      if (!productId) {
          let quickshopInput = document.querySelector("#quickshop input[name='product-id']");
          if (quickshopInput) {
              productId = quickshopInput.value; // Get product ID from input field
          }
      }
      
      if(domainName != "" && productId != ""){
        
        if (variantInput) {
          var data = {
            myshopifyDomain: btoa(domainName),
            product: btoa(productId),
            variantInput: btoa(variantInput)
          };
        }else{
          var data = {
            myshopifyDomain: btoa(domainName),
            product: btoa(productId)
          };
        }
        var jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: jsonString,
          redirect: "follow"
        };

        console.log('requestOptions',requestOptions);
  
        fetch(`https://subscriptions.gosimple.app/api/plans`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
              if (result.returnhtml) {
                if(result.returnhtml != ''){
                  var forms = document.querySelectorAll('form[action="/cart/add"]');
                  forms.forEach(function(form) {
                    form.style.display = 'none';
                  });
                }
                
                var productprice = document.querySelector('.price');
                if (productprice) {
                  productprice.style.display = 'none';
                }
          
                var variantSelects = document.querySelector('variant-selects');
                if (variantSelects) {
                  variantSelects.style.display = 'none';
                }
          
                var quantityInput = document.querySelector('quantity-input');
                if (quantityInput) {
                  quantityInput.style.display = 'none';
                  var closestLabel = quantityInput.previousElementSibling;
                  if (closestLabel && closestLabel.tagName.toLowerCase() === 'label') {
                    closestLabel.style.display = 'none';
                  }
                }
                if(postselctedtype){
                  if(postselctedtype == 'onetime'){
                      setTimeout(function() {
    						let defaultClickElement = document.querySelector(".clickbyonetime");
    						if (defaultClickElement) {
    							defaultClickElement.click();
    						}
                            document.querySelectorAll(".batchblocks").forEach(el => {
                                el.style.display = "block";
                            });
    					}, 300);
                  }else{
                      setTimeout(function() {
    						let defaultClickElement = document.querySelector(".clickbydefault");
    						if (defaultClickElement) {
    							defaultClickElement.click();
    						}
                            document.querySelectorAll(".batchblocks").forEach(el => {
                                el.style.display = "block";
                            });
    					}, 300);
                  }
                }else{
                  setTimeout(function() {
                        let defaultClickElement = document.querySelector(".clickbydefault");
                        if (defaultClickElement) {
                            defaultClickElement.click();
                        }
                        document.querySelectorAll(".batchblocks").forEach(el => {
                            el.style.display = "block";
                        });
                    }, 300);
                }
                
                
                let hwsInsertDiv = document.querySelector('#Hwsinsertlists');
                if (hwsInsertDiv) {
                  hwsInsertDiv.innerHTML = result.returnhtml;
                  appendAjaxResponseToDOM1(result.paystrackjs);
                }
                if(qty){
                  let inputField = document.querySelector(".Hw-subs-qty-input");
                  if(inputField){
                      inputField.value = qty;
                  }
                }
                
                
    
              }
          })
          .catch((error) => {
              console.error("Error:", error);
          });

      }
    }*/
function appendAjaxResponseToDOM1(response) {
          const container = document.createElement('div');
          container.innerHTML = response;
      
          // Append the button or other HTML content
          const button = container.querySelector('button.confirmpayment');
          if (button) {
              document.body.appendChild(button);
          }
      
          // Extract and execute script tags
          const scripts = container.querySelectorAll('script');
          scripts.forEach(script => {
              const newScript = document.createElement('script');
              if (script.src) {
                  // If the script is external
                  newScript.src = script.src;
              } else {
                  // Inline script
                  newScript.textContent = script.textContent;
              }
              document.body.appendChild(newScript);
          });
      }
if(domainName != "" ){
    (function () {
        var CHECKFREQ_URL = "https://subscriptions.gosimple.app/api/checkfreq";

        var addHiddenInput2 = function (form, name, value) {
            var existing = form.querySelector('input[name="' + name + '"]');
            if (existing) existing.remove();
            var hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = name;
            hiddenInput.value = value;
            form.appendChild(hiddenInput);
        };

        var showError2 = function (message) {
            var planList = document.getElementById("Hwsinsertlists");
            var errorMessage = document.getElementById("planErrorMessage");
            if (errorMessage) {
                errorMessage.textContent = message;
                errorMessage.style.display = "block";
            } else {
                errorMessage = document.createElement("div");
                errorMessage.id = "planErrorMessage";
                errorMessage.style.color = "red";
                errorMessage.textContent = message;
                if (planList) {
                    planList.insertAdjacentElement("beforebegin", errorMessage);
                } else {
                    document.body.prepend(errorMessage);
                }
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
        };

        var showError = showError2;

        function hidePlanError() {
            var errorMessage = document.getElementById("planErrorMessage");
            if (errorMessage) errorMessage.style.display = "none";
        }

        function hwIsSubscribeMode() {
            var toggle = document.querySelector(".subsoptionsforsel:checked");
            if (toggle) {
                return toggle.getAttribute("data-id") === "subscription";
            }
            if (document.querySelector(".hw-w-one-time-box input.subsoptionsforsel:checked")) {
                return false;
            }
            if (document.querySelector(".hw-w-subscription-box input.subsoptionsforsel:checked")) {
                return true;
            }
            return true;
        }

        function hwGetActiveFreqSelect() {
            if (!hwIsSubscribeMode()) return null;

            var activeBox = document.querySelector(".hw-w-subscription-box.active");
            if (activeBox) {
                var sel = activeBox.querySelector("select.unplanfrequancy");
                if (sel) return sel;
            }
            var visibleBatch = document.querySelector(
                ".batchblocks:not([style*='display: none']) select.unplanfrequancy"
            );
            if (visibleBatch) return visibleBatch;
            return document.querySelector("select.unplanfrequancy");
        }

        function hwSelectOnetimePlanRadio() {
            var radio = document.querySelector(
                '#hwsubsplanlist li.trigger-ID-onetime input[name="subscriptionplan"]'
            );
            if (radio) {
                radio.checked = true;
                return radio;
            }
            return null;
        }

        function hwSyncFrequencyToPlanRadio() {
            if (!hwIsSubscribeMode()) {
                return hwSelectOnetimePlanRadio();
            }

            var freqSelect = hwGetActiveFreqSelect();
            if (!freqSelect || !freqSelect.value) return null;

            var freqValue = String(freqSelect.value);
            var radio = document.querySelector(
                "#hwsubsplanlist li.trigger-ID-" +
                    CSS.escape(freqValue) +
                    ' input[name="subscriptionplan"]'
            );
            if (radio) {
                radio.checked = true;
                return radio;
            }
            return null;
        }

        function hwGetActiveSubscriptionPlan() {
            if (!hwIsSubscribeMode()) {
                return hwSelectOnetimePlanRadio();
            }

            hwSyncFrequencyToPlanRadio();
            var checked = document.querySelector(
                'ul#hwsubsplanlist input[name="subscriptionplan"]:checked'
            );
            if (checked && checked.value !== "onetime") return checked;
            return hwSyncFrequencyToPlanRadio();
        }

        function hwParseCheckfreqAllowed(result) {
            var text = String(result || "").trim().toLowerCase();
            if (text === "0" || text === "false") return false;
            if (text === "1" || text === "true") return true;
            try {
                var json = JSON.parse(result);
                if (json && json.allowed === false) return false;
                if (json && json.ok === false) return false;
            } catch (e) {}
            return text !== "";
        }

        function kassAfterCartAdd(mainbuttontext, originalText) {
            return fetch("/cart/add.js", {
                method: "POST",
                body: new FormData(
                    document.querySelector("body #Hwsinsertlists form")
                ),
            })
                .then(function (res) {
                    return res.json();
                })
                .then(function () {
                    return fetch("/cart.js");
                })
                .then(function (res) {
                    return res.json();
                })
                .then(function (cart) {
                    if (typeof doUpdateDropdownCartCustom === "function") {
                        doUpdateDropdownCartCustom(cart);
                    }
                    setTimeout(function () {
                        if (mainbuttontext) mainbuttontext.innerHTML = originalText;
                    }, 1500);
                });
        }

        document.querySelectorAll(".subsoptionsforsel").forEach(function (radio) {
            radio.addEventListener("change", function () {
                if (this.getAttribute("data-id") === "onetime") {
                    hwSelectOnetimePlanRadio();
                } else {
                    hwSyncFrequencyToPlanRadio();
                }
            });
        });

        document.querySelectorAll("select.unplanfrequancy").forEach(function (select) {
            select.addEventListener("change", function () {
                if (hwIsSubscribeMode()) {
                    hwSyncFrequencyToPlanRadio();
                }
            });
        });

        document.body.addEventListener("click", function (event) {
            var button = event.target.closest("#hwsubsCheckout");
            if (!button) return;

            event.preventDefault();
            hidePlanError();

            console.log("hwsubsCheckout");

            var spinner = document.createElement("span");
            spinner.innerHTML =
                '<svg class="spinner" width="20" height="20" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="white" stroke-dasharray="90,150" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"/></circle></svg>';
            spinner.style.marginLeft = "10px";
            spinner.style.display = "inline-block";

            button.disabled = true;
            button.style.opacity = "0.5";
            button.appendChild(spinner);

            var selectedPlan = hwGetActiveSubscriptionPlan();

            if (!selectedPlan) {
                showError("Please select a plan");
                button.disabled = false;
                button.style.opacity = "1";
                spinner.remove();
                return;
            }

            var planValue = selectedPlan.value;
            var planSubtype = selectedPlan.getAttribute("data-subtype");
            var value = selectedPlan.getAttribute("data-frid");
            var desc = selectedPlan.getAttribute("data-desc");
            var actualprice = selectedPlan.getAttribute("data-actual");
            var discountprice = selectedPlan.getAttribute("data-discount");

            var nearestForm = document.querySelector("body #Hwsinsertlists form");
            if (!nearestForm) {
                showError("Product form not found. Please refresh the page and try again.");
                button.disabled = false;
                button.style.opacity = "1";
                spinner.remove();
                return;
            }

            function kassFinish() {
                button.disabled = false;
                button.style.opacity = "1";
                spinner.remove();
            }

            function kassAddToCart() {
                var mainbuttontext = document.querySelector(".hwsubsCheckouttext");
                var originalText = mainbuttontext ? mainbuttontext.innerHTML : "";

                if (planValue !== "onetime") {
                    if (mainbuttontext) mainbuttontext.textContent = "Added";
                    addHiddenInput2(nearestForm, "properties[Subscription]", planSubtype);
                    addHiddenInput2(nearestForm, "properties[Description]", desc);
                    addHiddenInput2(nearestForm, "properties[actualprice]", actualprice);
                    addHiddenInput2(nearestForm, "properties[discountprice]", discountprice);
                    addHiddenInput2(nearestForm, "properties[subscode]", value);
                } else {
                    if (mainbuttontext) mainbuttontext.textContent = "Added";
                    [
                        "properties[Subscription]",
                        "properties[Description]",
                        "properties[actualprice]",
                        "properties[discountprice]",
                        "properties[subscode]",
                    ].forEach(function (name) {
                        var input = nearestForm.querySelector('input[name="' + name + '"]');
                        if (input) input.remove();
                    });
                }

                var formData = new FormData(nearestForm);

                return fetch("/cart/add.js", {
                    method: "POST",
                    body: formData,
                })
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function () {
                        return fetch("/cart.js");
                    })
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function (cart) {
                        if (typeof doUpdateDropdownCartCustom === "function") {
                            doUpdateDropdownCartCustom(cart);
                        }
                        setTimeout(function () {
                            if (mainbuttontext) mainbuttontext.innerHTML = originalText;
                        }, 1500);
                    })
                    .catch(function (error) {
                        console.error("Error submitting form:", error);
                        showError("Could not add this item to your cart. Please try again.");
                    });
            }

            // One-time: add to cart only (no checkfreq)
            if (planValue === "onetime") {
                kassAddToCart().finally(kassFinish);
                return;
            }

            // Subscribe: check frequency, then add with subscription properties
            if (typeof domainName === "undefined" || !domainName) {
                showError("Store configuration error. Please refresh the page and try again.");
                kassFinish();
                return;
            }

            fetch("/cart.js", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (cart) {
                    console.log("Cart token:", cart.token);

                    return fetch(CHECKFREQ_URL, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            myshopifyDomain: btoa(domainName),
                            product: value,
                            cart_token: cart.token,
                        }),
                    });
                })
                .then(function (response) {
                    return response.text();
                })
                .then(function (result) {
                    console.log(result);

                    if (!hwParseCheckfreqAllowed(result)) {
                        showError(
                            "Oops! It looks like you're trying to add items with different delivery schedules to the same subscription."
                        );
                        return;
                    }

                    return kassAddToCart();
                })
                .catch(function (error) {
                    console.error("Error:", error);
                    showError("An error occurred. Please try again.");
                })
                .finally(kassFinish);
        });

        if (hwIsSubscribeMode()) {
            hwSyncFrequencyToPlanRadio();
        } else {
            hwSelectOnetimePlanRadio();
        }
    })();

    // Function to add hidden input fields to the form
    function addHiddenInput(form, name, value) {
        var hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = name;
        hiddenInput.value = value;
        form.appendChild(hiddenInput);
    }

    // Function to show error messages
    function showError(message) {
        var planList = document.getElementById("Hwsinsertlists");
        var errorMessage = document.getElementById("planErrorMessage");

        if (!errorMessage) {
            errorMessage = document.createElement("div");
            errorMessage.id = "planErrorMessage";
            errorMessage.style.color = "red";
            errorMessage.textContent = message;
            planList.insertAdjacentElement("beforebegin", errorMessage);
        } else {
            errorMessage.textContent = message;
            errorMessage.style.display = "block";
        }

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
/*document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded event triggered");

    // Get query string parameters
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionCode = urlParams.get("code");
    const shopCode = urlParams.get("shop");

    if (subscriptionCode && shopCode) {
        // Show loading spinner
        const custSubsListElement = document.querySelector("body .hw-cust-subs-list");
        if (custSubsListElement) {
            custSubsListElement.style.display = "block";
        }

        const data = {
            action: "subscripitonDetail",
            shop: shopCode,
            code: subscriptionCode,
        };

        const jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: jsonString,
            redirect: "follow",
        };

        // Set a timeout to handle scenarios where the API takes too long to respond
        const timeoutId = setTimeout(() => {
            if (custSubsListElement) {
                custSubsListElement.style.display = "none";
            }
            console.error("Request timed out. Please try again later.");
        }, 5000); // Timeout set to 10 seconds (adjust as needed)

        fetch(`https://subscriptions.gosimple.app/api/subscription-detail`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                clearTimeout(timeoutId); // Clear timeout on successful response

                if (custSubsListElement) {
                    custSubsListElement.style.display = "none";
                }

                const subDetailElement = document.querySelector("body #subdetail");
                if (subDetailElement) {
                    subDetailElement.innerHTML = result.returnhtml || "No details available";
                    subDetailElement.style.display = "block";
                }
            })
            .catch((error) => {
                clearTimeout(timeoutId); // Clear timeout even if there's an error
                if (custSubsListElement) {
                    custSubsListElement.style.display = "none";
                }
                console.error("Error:", error);
            });
    }
});*/


document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded");

    document.addEventListener("click", function (e) {
        const checkoutButton = e.target.closest('button[name="checkout"], input[name="checkout"], #checkout, .hwsbuttonclick');
        
        if (checkoutButton) {
            console.log("Checkout button clicked");
            e.preventDefault();

            fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                    const hasSubscriptionItem = cart.items.some(item =>
                        item.properties && item.properties.Subscription
                    );

                    let packagingSolution = "";
                    const tosAgreeInputs = document.querySelectorAll('.tos_agree');

                    tosAgreeInputs.forEach(input => {
                        if (input.checked) {
                            packagingSolution = input.value;
                        }
                    });

                    if (hasSubscriptionItem) {
                        fetch("/cart.js")
                            .then(response => response.json())
                            .then(cart => {
                                console.log("Cart Data:", cart);
                                const shopDomain = Shopify.shop;
                                const cartTokenFull = cart.token;
                                const userEmail = window.customerData?.email || "";

                                let cartToken = "";
                                let key = "";

                                if (cartTokenFull.includes("?key=")) {
                                    const parts = cartTokenFull.split("?key=");
                                    cartToken = parts[0];
                                    key = parts[1];
                                } else {
                                    cartToken = cartTokenFull;
                                }

                                const encodedData = btoa(JSON.stringify({
                                    shop: shopDomain,
                                    cart_token: cartToken,
                                    key: key,
                                    userEmail: userEmail,
                                    packagingSolution: packagingSolution
                                }));

                                const customCheckoutUrl = `https://subscriptions.gosimple.app/checkout/hw/${encodedData}`;
                                window.location.href = customCheckoutUrl;
                            })
                            .catch(error => {
                                console.error("Error fetching cart:", error);
                            });
                    } else {
                        window.location.href = "/checkout";
                    }
                })
                .catch(error => {
                    console.error("Error fetching cart:", error);
                });
        }
    });
});



setTimeout(function(){
  const currentURL = window.location.href;
  if (currentURL.includes("/pages/payment-method")) {
      const data = {
          action: "subsbyemail",
          myshopifyDomain: btoa(domainName),
      };

      const jsonString = JSON.stringify(data);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: jsonString,
          redirect: "follow",
      };

      fetch(`https://subscriptions.gosimple.app/api/subscriptionsByemail`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if (result) {
                const subs = document.querySelector('#fetchhw-subs');
              
                if (subs) {
                    subs.innerHTML = result.returnhtml;
                    appendAjaxResponseToDOM(result.paystackjs);
                }
  
            }
        })
        .catch((error) => {
            
            console.error("Error:", error);
        });
  }else{
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionCode = urlParams.get("c");
    const subscriptionEmail = urlParams.get("e");

    if (subscriptionCode) {
        const data = {
            action: "subscripitonDetail",
            code: subscriptionCode,
        };

        const jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: jsonString,
            redirect: "follow",
        };

        fetch(`https://subscriptions.gosimple.app/api/subscription-detail`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result) {
                    const subs = document.querySelector('#fetchhw-subs');
                  
                    if (subs) {
                        subs.innerHTML = result.returnhtml;
                        appendAjaxResponseToDOM(result.paystackjs);
                    }
      
                }
            })
            .catch((error) => {
                
                console.error("Error:", error);
            });
    }
    else{
      
        var hwscustomer = document.querySelector('input[name="hws-customer"]');
        if (hwscustomer) {
        var customerval = hwscustomer.value;
            if(domainName != ""){
              
              var data = {
                myshopifyDomain: btoa(domainName),
                customer:btoa(customerval)
              };
              
              var jsonString = JSON.stringify(data);
              const myHeaders = new Headers();
              myHeaders.append("Content-Type", "application/json");
              const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: jsonString,
                redirect: "follow"
              };
              console.log(requestOptions);
              fetch("https://subscriptions.gosimple.app/api/subscriptions", requestOptions)
              .then((response) => response.json()) // Expecting a JSON response
                  .then((result) => {
                      if (result) {
                        console.log(result);
                    const subs = document.querySelector('#fetchhw-subs');
                    if (subs) {
                        subs.innerHTML = result.returnhtml;
                        appendAjaxResponseToDOM(result.paystackjs);
                    }
      
                }
              })
              .catch((error) => console.error(error));
            }
      }else{
          const subs = document.querySelector('#fetchhw-subs');
            if (subs) {
                subs.innerHTML = '';
            }
      }

    }
  }

   function appendAjaxResponseToDOM(response) {
          const container = document.createElement('div');
          container.innerHTML = response;
      
          // Append the button or other HTML content
          const button = container.querySelector('button.confirmpayment');
          if (button) {
              document.body.appendChild(button);
          }
      
          // Extract and execute script tags
          const scripts = container.querySelectorAll('script');
          scripts.forEach(script => {
              const newScript = document.createElement('script');
              if (script.src) {
                  // If the script is external
                  newScript.src = script.src;
              } else {
                  // Inline script
                  newScript.textContent = script.textContent;
              }
              document.body.appendChild(newScript);
          });
      }
  
},300);



// Widget Load JS
function initSubscriptionJS() {
    document.querySelectorAll(".unplanfrequancy").forEach(function(selectBox) {
            selectBox.addEventListener("change", function() {
                const selectedId = this.value;

                if (!document.querySelector(".hw-w-subscription-box")) {
                    console.warn(".hw-w-subscription-box not found in the HTML");
                    return; // stop further execution
                }
                
                // Find the closest subscription container
                const container = this.closest(".hw-w-subscription-box");
                
                // Update frequency description visibility
                const descBox = container.querySelector(".hw-w-feature-list");
                if (descBox) {
                    descBox.querySelectorAll("span[class^=\'feature-span\']").forEach(function(span) {
                        span.style.display = "none";
                    });

                    const selectedDesc = descBox.querySelector("#frqID_" + selectedId);
                    if (selectedDesc) {
                        selectedDesc.style.display = "block";
                    }
                }
            });
        });

       /* const selectcheck = document.querySelector(".unplanfrequancy");
        if(selectcheck) {
            selectcheck.querySelectorAll("option").forEach(option => {
                option.textContent = option.textContent.replace(/Weeks/gi, "WKS");
            });
        }*/

        document.querySelectorAll(".hw-w-schedule-option").forEach(function(option) {
            option.addEventListener("click", function() {
                const selectedId = this.getAttribute("data-frequency-id");

                // Remove active class from all siblings
                const allOptions = this.closest(".hw-w-schedule-options").querySelectorAll(".hw-w-schedule-option");
                allOptions.forEach(function(opt) {
                    opt.classList.remove("active");
                });
                this.classList.add("active");

                // Set the value of the related select
                const container = this.closest(".hw-w-subscription-box");
                const selectBox = container.querySelector(".unplanfrequancy");
                if (selectBox) {
                    selectBox.value = selectedId;
                    selectBox.dispatchEvent(new Event("change"));
                }

                // Update frequency description visibility
                const descBox = container.querySelector(".hw-w-feature-list");
                if (descBox) {
                    descBox.querySelectorAll("span[class^=\'feature-span\']").forEach(function(span) {
                        span.style.display = "none";
                    });

                const selectedDesc = descBox.querySelector("#frqID_" + selectedId);
                if (selectedDesc) {
                    selectedDesc.style.display = "block";
                }
            }
        });
    }); 
    document.addEventListener("click", function(e) {
            let btn = e.target.closest(".varoption-btn");
            if (btn) {
                let group = btn.getAttribute("data-option");
            let value = btn.getAttribute("data-value");

            // Remove active class from siblings
            document.querySelectorAll(".variant-group-" + group + " .varoption-btn")
                .forEach(function(b) {
                    b.classList.remove("hwsim-active");
                });

                // Add active class
                btn.classList.add("hwsim-active");

            // Update hidden select + trigger change ONCE
            let hiddenSelect = document.querySelector(".varoption" + group);
            if (hiddenSelect) {
                if (hiddenSelect.value !== value) { // only trigger if changed
                    hiddenSelect.value = value;
                    hiddenSelect.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
        }
    });


    function updateVariantSelect() {
        const variantSelect = document.querySelector("#variantSelect");					
        let mainbuttontext = document.querySelector(".subUnavailable");
        let mainbthhide = document.querySelector(".mainbthhide");
        const hiddenSelect = document.querySelector("#hidden-variant-select");
        let selectedValues = Array.from(document.querySelectorAll(".varoption"))
        .map(select => select.value.trim())
        .filter(value => value !== "");
            const spinner = document.querySelector("#hwsubsCheckout span");
            const subbutton = document.querySelector("#hwsubsCheckout");
            let qtyvalbeforechange = document.querySelector(".Hw-subs-qty-input").value;
            console.log(qtyvalbeforechange);
            if (selectedValues.length === 0) return;
            let matchFound = false;
            Array.from(variantSelect.options).forEach(option => {
            const optionValues = option.dataset.value.split(" / ").map(val => val.trim());
        
            if (selectedValues.length === optionValues.length && 
                selectedValues.every((val, index) => val === optionValues[index])) {
                if (mainbuttontext && mainbthhide) {
                    mainbuttontext.style.display = "none";
                    mainbthhide.style.display = "block"; 
                }
                if(spinner){
                    spinner.innerHTML =
                        `<svg class="spinner" width="20" height="20" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="white" stroke-dasharray="90,150" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"/></circle></svg>`;
                    spinner.style.marginLeft = "10px";
                    spinner.style.display = "inline-block";
                }
                if(subbutton){
                    subbutton.disabled = true;
                    subbutton.style.opacity = "0.5";
                }

                option.selected = true;
                matchFound = true;
                var postselctedtype = "";
                var checkedPlans = document.querySelectorAll(
                    "ul#hwsubsplanlist input[name=subscriptionplan]:checked"
                );
                if(checkedPlans.length > 0){
                    var selectedPlan = checkedPlans[0];
                    var planValue = selectedPlan.value;
                    if(planValue == "onetime"){
                        postselctedtype = planValue;
                    }
                }
                //loadHwsPlans(option.value,qtyvalbeforechange,postselctedtype);
                console.log("Matched Variant:", option.textContent);
                variantSelect.dispatchEvent(new Event("change"));
                const matchedHiddenOption = Array.from(hiddenSelect.options).find(
                    opt => opt.dataset.value.trim() === option.textContent.trim()
                );
                const isAvailable = String(matchedHiddenOption.dataset.available) === "true";
                console.log(isAvailable ? "Available ✅" : "Sold Out ❌");
                if (isAvailable) {
                  document.querySelector(".hwsubsCheckouttext").textContent = "Add to Subscription";
                  document.querySelector("#hwsubsCheckout").disabled = false;
                  loadHwsPlans(option.value,qtyvalbeforechange,postselctedtype);
                } 
                else {
                    document.querySelector(".hwsubsCheckouttext").textContent = "Sold Out";
                    document.querySelector("#hwsubsCheckout").disabled = true;
                    document.querySelector("#Hw-GetSubsPrice").style.display = "none";
                }
                
            }
        });

        if (!matchFound) {
            if (mainbuttontext && mainbthhide) {
                mainbuttontext.style.display = "block";
                mainbthhide.style.display = "none";
            }
            variantSelect.selectedIndex = 0;
            variantSelect.dispatchEvent(new Event("change"));
        }
    }

    document.querySelectorAll(".varoption").forEach(select => {
        select.removeEventListener("change", updateVariantSelect); // clear old
        select.addEventListener("change", updateVariantSelect);
    });

    document.querySelectorAll(`.uphwsubsplanlist li input[type="radio"]`).forEach((radio) => {
        radio.addEventListener("change", function () {
            if (this.checked) {
                let selectedValue = this.value;
                console.log("Selected Plan Value:", selectedValue);
                if(selectedValue == "onetime"){
                    let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-onetime input[type="radio"]`);
                    if (radioInput) {
                        radioInput.checked = true;
                    }
                }else{
                    let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-${selectedValue} input[type="radio"]`);
                    if (radioInput) {
                        radioInput.checked = true;
                    }
                }	
            }
        });
    });

    	
    function handleSubscriptionSelection(event) {
        let radio = event.target;
        if (radio.checked) {
            let planId = radio.getAttribute("data-plan-id");
            let optionId = radio.getAttribute("data-id");
            let value = radio.value;

            let mainbuttontext = document.querySelector(".hwsubsCheckouttext");
            let qtyinput = document.querySelector(".Hw-subs-qty-input");
            let advhmprice = document.querySelector(".advhw-price-line");
            let advhmsavings = document.querySelector(".advhw-savings");
            let shoppriceif = document.querySelector(".product-block--price .money");

            document.querySelectorAll(".hwplanfrqdreopdown, .Hw-subs-description span, .Hw-subs-description")
                .forEach(el => el.style.display = "none");

            if (optionId === "subscription") {
                if (mainbuttontext) {
                    let subsalepriceText = document.querySelector(".changesubprice")?.textContent.trim() || "";
                    let oneoffpriceElement = document.querySelector(".oneoffpricecompare");

                    if (!oneoffpriceElement || oneoffpriceElement.textContent.trim() === "") {
                        oneoffpriceElement = document.querySelector(".oneoffprice");
                    }
                    let oneoffpriceText = oneoffpriceElement ? oneoffpriceElement.textContent.trim() : "";

                    // --- Use shared function ---
                    updateMainButtonDisplay({
                        type: "subscription",
                        subsalepriceText,
                        oneoffpriceText,
                        mainbuttontext,
                        advhmprice,
                        advhmsavings,
                        shoppriceif,
                        qty: parseInt(qtyinput?.value || 1)
                    });
                }

                let parentDiv = document.querySelector(".batchID-" + planId);
                if (parentDiv) {
                    showElement(parentDiv.querySelector(".hwplanfrqdreopdown"));
                    showElement(parentDiv.querySelector(".Hw-subs-description"));

                    let unplanFrequencySelect = parentDiv.querySelector("select.unplanfrequancy");
                    if (unplanFrequencySelect) {
                        document.querySelectorAll("span[id^='frqID_']").forEach(span => span.style.display = "none");
                        let firstOptionValue = unplanFrequencySelect.options[0]?.value;
                        showElement(document.querySelector("#frqID_" + firstOptionValue));

                        let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-${firstOptionValue} input[type="radio"]`);
                        if (radioInput) radioInput.checked = true;
                    }
                }
            } else {
                // --- One-time purchase ---
                if (mainbuttontext) {
                    let oneoffpriceElement = document.querySelector(".oneoffpricecompareonce");
                    let subsaleprice = "";

                    if (oneoffpriceElement && oneoffpriceElement.textContent.trim() !== "") {
                        let comparePriceText = oneoffpriceElement.textContent.trim();
                        let actualPriceText = document.querySelector(".oneoffprice")?.textContent.trim() || "";

                        updateMainButtonDisplay({
                            type: "onetime",
                            comparePriceText,
                            actualPriceText,
                            mainbuttontext,
                            advhmprice,
                            advhmsavings,
                            shoppriceif,
                            qty: parseInt(qtyinput?.value || 1)
                        });
                    } else {
                        subsaleprice = document.querySelector(".oneoffprice")?.textContent || "";
                        updateMainButtonDisplay({
                            type: "onetime",
                            subsalepriceText: subsaleprice,
                            mainbuttontext,
                            advhmprice,
                            advhmsavings,
                            shoppriceif,
                            qty: parseInt(qtyinput?.value || 1)
                        });
                    }
                }

                let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-onetime input[type="radio"]`);
                if (radioInput) radioInput.checked = true;
            }
        }
    }


    function handleFrequencyChange(event) {
        let select = event.target;
        let selectedOption = select.options[select.selectedIndex];
        let planId = selectedOption.getAttribute("planid");
        let discountValue = parseFloat(selectedOption.getAttribute("data-discount_value")) || 0;
        let discountType = selectedOption.getAttribute("data-discount_type");
        let amount = parseFloat(selectedOption.getAttribute("data-amount")) || 0;
        let shopCurrency = selectedOption.getAttribute("data-shopcurrency") || "";
        let qtyinput = document.querySelector(".Hw-subs-qty-input");

        let parentDiv = document.querySelector(".batchID-" + planId);
        if (parentDiv) {
            let discountedAmount = calculateDiscount(amount, discountValue, discountType);
            let discountedText = shopCurrency + " " + discountedAmount.toFixed(2);

            updateTextContent(parentDiv.querySelector("span.changesubprice"), discountedText);
            let planshopid = document.querySelector("#planshopid").value;
            updateDiscountDisplay(parentDiv.querySelector("span.changesubdiscount"), discountValue, planshopid);

            document.querySelectorAll(".Hw-subs-description span").forEach(el => el.style.display = "none");
            showElement(parentDiv.querySelector(".Hw-subs-description #frqID_" + select.value));

            let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-${select.value} input[type="radio"]`);
            if (radioInput) radioInput.checked = true;

            // --- Use shared function for display update ---
            let oneoffpriceText = document.querySelector(".oneoffpricecompare")?.textContent.trim() || document.querySelector(".oneoffprice")?.textContent.trim() || "";

            updateMainButtonDisplay({
                type: "subscription",
                subsalepriceText: discountedText,
                oneoffpriceText,
                mainbuttontext: document.querySelector(".hwsubsCheckouttext"),
                advhmprice: document.querySelector(".advhw-price-line"),
                advhmsavings: document.querySelector(".advhw-savings"),
                shoppriceif: document.querySelector(".product-block--price .money"),
                qty: parseInt(qtyinput?.value || 1)
            });
        }
    }


    // 🔹 NEW FUNCTION: handle quantity change
    function handleQuantityChange(value, inputElement) {
        let qty = value;
        console.log("Quantity changed:", qty);

        // ✅ Use your actual selector
        let selectedRadio = document.querySelector(".hw-w-subcription-widget-box input[name='toggle']:checked");
        if (!selectedRadio) return;

        let isSubscription = selectedRadio.getAttribute("data-id") === "subscription";

        let mainbuttontext = document.querySelector(".hwsubsCheckouttext");
        let advhmprice = document.querySelector(".advhw-price-line");
        let advhmsavings = document.querySelector(".advhw-savings");
        let shoppriceif = document.querySelector(".product-block--price .money");

        if (isSubscription) {
            // 🌀 Subscription path
            let subsalepriceText = document.querySelector(".changesubprice")?.textContent.trim() || "";
            let oneoffpriceText =
                document.querySelector(".oneoffpricecompare")?.textContent.trim() ||
                document.querySelector(".oneoffprice")?.textContent.trim() || "";

            updateMainButtonDisplay({
                type: "subscription",
                subsalepriceText,
                oneoffpriceText,
                mainbuttontext,
                advhmprice,
                advhmsavings,
                shoppriceif,
                qty
            });

        } else {
            // 💰 One-time purchase path
            let comparePriceText = document.querySelector(".oneoffpricecompareonce")?.textContent.trim() || "";
            let actualPriceText = document.querySelector(".oneoffprice")?.textContent.trim() || "";

            updateMainButtonDisplay({
                type: "onetime",
                comparePriceText,
                actualPriceText,
                mainbuttontext,
                advhmprice,
                advhmsavings,
                shoppriceif,
                qty
            });
        }
    }



    // 🔹 SHARED FUNCTION: handles all button text, price, savings updates
    function updateMainButtonDisplay({ type, subsalepriceText = "", oneoffpriceText = "", comparePriceText = "", actualPriceText = "", mainbuttontext, advhmprice, advhmsavings, shoppriceif, qty = 1 }) {
        if (!mainbuttontext) return;

        let currencySymbol = (subsalepriceText || oneoffpriceText || comparePriceText || actualPriceText).match(/^\D+/)?.[0] || "";
        let subsalepriceNum = parseFloat(subsalepriceText.replace(/[^\d.]/g, "")) || 0;
        let oneoffpriceNum = parseFloat(oneoffpriceText.replace(/[^\d.]/g, "")) || 0;
        let compareNum = parseFloat(comparePriceText.replace(/[^\d.]/g, "")) || 0;
        let actualNum = parseFloat(actualPriceText.replace(/[^\d.]/g, "")) || 0;

        let oneoffprice = document.querySelector(".oneoffprice");
        let changesubprice = document.querySelector(".changesubprice");

        let qtyLabel = qty > 1 ? ` (x${qty})` : "";

        if (type === "subscription") {
            let totalSubPrice = (subsalepriceNum * qty).toFixed(2);
            let totalOneOff = (oneoffpriceNum * qty).toFixed(2);

            if (!isNaN(totalOneOff) && totalOneOff > totalSubPrice) {
                let savingsAmount = (totalOneOff - totalSubPrice).toFixed(2);
                let savingsPercent = (((totalOneOff - totalSubPrice) / totalOneOff) * 100).toFixed(0);

                mainbuttontext.innerHTML = `${currencySymbol}${totalSubPrice}${qtyLabel} &nbsp;<span style="text-decoration:line-through;font-weight: 500;"> ${currencySymbol}${totalOneOff}</span> <span style="font-weight:200;color:#444;padding:0 0 0 4px;">|</span> Add to Subscription`;
                //changesubprice.innerHTML = `${currencySymbol}${totalSubPrice}`;
                if (advhmprice) advhmprice.innerHTML = `<span class="advhw-current-price">${currencySymbol}${totalSubPrice}</span> <span class="advhw-compare-price">${currencySymbol}${totalOneOff}</span>`;
                if (advhmsavings) advhmsavings.innerHTML = `Savings <span class="advhw-savings-amount">${currencySymbol}${savingsAmount}</span> <span class="advhw-savings-percent">(${savingsPercent}%)</span>`;
                if (shoppriceif) shoppriceif.innerHTML = `${currencySymbol}${totalSubPrice} &nbsp;<span style="text-decoration:line-through;font-weight:500;"> ${currencySymbol}${totalOneOff}</span>`;
            } else {
                mainbuttontext.innerHTML = `${currencySymbol}${totalSubPrice}${qtyLabel} <span style="font-weight:200;color:#444;padding:0 0 0 4px;">|</span> Add to Subscription`;
                if (advhmprice) advhmprice.innerHTML = `<span class="advhw-current-price">${currencySymbol}${totalSubPrice}</span>`;
                if (advhmsavings) advhmsavings.innerHTML = "";
                if (shoppriceif) shoppriceif.innerHTML = `${currencySymbol}${totalSubPrice}`;
                //changesubprice.innerHTML = `${currencySymbol}${totalSubPrice}`;

            }
        } else {
            let totalActual = (actualNum * qty).toFixed(2);
            let totalCompare = (compareNum * qty).toFixed(2);

            if (!isNaN(totalCompare) && totalCompare > totalActual) {
                let savingsAmount = (totalCompare - totalActual).toFixed(2);
                let savingsPercent = (((totalCompare - totalActual) / totalCompare) * 100).toFixed(0);
                //oneoffprice.innerHTML = `${currencySymbol}${totalActual}`;
                mainbuttontext.innerHTML = `${currencySymbol}${totalActual}${qtyLabel} &nbsp;<span style="text-decoration:line-through;font-weight: 500;"> ${currencySymbol}${totalCompare}</span> <span style="font-weight:200;color:#444;padding:0 0 0 4px;">|</span> Add to Cart`;
                if (advhmprice) advhmprice.innerHTML = `<span class="advhw-current-price">${currencySymbol}${totalActual}</span> <span class="advhw-compare-price">${currencySymbol}${totalCompare}</span>`;
                if (advhmsavings) advhmsavings.innerHTML = `Savings <span class="advhw-savings-amount">${currencySymbol}${savingsAmount}</span> <span class="advhw-savings-percent">(${savingsPercent}%)</span>`;
                if (shoppriceif) shoppriceif.innerHTML = `${currencySymbol}${totalActual} &nbsp;<span style="text-decoration:line-through;font-weight:500;"> ${currencySymbol}${totalCompare}</span>`;
            } else {
                //oneoffprice.innerHTML = `${currencySymbol}${totalActual}`;
                mainbuttontext.innerHTML = `${currencySymbol}${totalActual}${qtyLabel} <span style="font-weight:200;color:#444;padding:0 0 0 4px;">|</span> Add to Cart`;
                if (advhmprice) advhmprice.innerHTML = `<span class="advhw-current-price">${currencySymbol}${totalActual}</span>`;
                if (advhmsavings) advhmsavings.innerHTML = "";
                if (shoppriceif) shoppriceif.innerHTML = `${currencySymbol}${totalActual}`;
            }
        }
    }

    function calculateDiscount(amount, discountValue, discountType) {
        if (discountType === "percentage") {
            return amount - (amount * (discountValue / 100));
        } else if (discountType === "fixed") {
            return amount - discountValue;
        }
        return amount;
    }

    function showElement(element) {
        if (element && element.textContent.trim() !== "") {
            element.style.display = "block";
        }
    }

    function updateTextContent(element, text) {
        if (element) element.textContent = text;
    }

    function updateDiscountDisplay(element, discountValue, planshopid) {
        if (element) {
            if(planshopid == 12){
                if (discountValue > 0) {
                    element.textContent = "Save";
                    element.style.display = "block";
                } else {
                    element.style.display = "none";
                }
            }else{
                if (discountValue > 0) {
                    element.textContent = "Save " + discountValue + "%";
                    element.style.display = "block";
                } else {
                    element.style.display = "none";
                }
            }
        }
    }

    document.querySelectorAll(".subsoptionsforsel").forEach(radio => {
    radio.addEventListener("change", async () => {
        const variantInput = await getVariantParamValue();
        setTimeout(function() {
        const hiddenSelect = document.querySelector('#hidden-variant-select');
        if (!hiddenSelect) return;
        const matchedHiddenOption = Array.from(hiddenSelect.options).find(
            opt => opt.dataset.id === String(variantInput)
        );
        if (!matchedHiddenOption) {
            console.log(':x: No matching variant found in hidden select');
            return;
        }
        const isAvailable = String(matchedHiddenOption.dataset.available) === 'true';
        const checkoutText = document.querySelector('.hwsubsCheckouttext');
        const checkoutBtn = document.querySelector('#hwsubsCheckout');
        const subsPrice = document.querySelector('#Hw-GetSubsPrice');
        if (!isAvailable) {
            console.log(isAvailable ? 'Available :white_check_mark:' : 'Sold Out :x:');
            if (checkoutText) checkoutText.textContent = 'Sold Out';
            if (checkoutBtn) checkoutBtn.disabled = true;
            if (subsPrice) subsPrice.style.display = 'none';
        } else {
            // :white_check_mark: Only run this when available
            const checkedRadio = document.querySelector('.subsoptionsforsel:checked');
            handleSubscriptionSelection({ target: checkedRadio });
        }
        }, 500);
    });
    });

    document.querySelectorAll("select.unplanfrequancy").forEach(select => {
        select.addEventListener("change", handleFrequencyChange);
    });

    document.getElementById("planvariantSelect").addEventListener("change", function () {
            let selectedValue = this.value;
            console.log(selectedValue);
            document.querySelectorAll(".batchblocks").forEach(el => {
                el.style.display = "none";
            });

            let selectedBatch = document.querySelector(".batchID-" + selectedValue);
            if (selectedBatch) {
                selectedBatch.style.display = "block";
                let defaultClickElement = selectedBatch.querySelector(".clickbydefault");
                if (defaultClickElement) {
                    defaultClickElement.click();
                    document.querySelectorAll(".batchblocks").forEach(el => {
                        el.style.display = "block";
                    });
                }
            }

            /*let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-onetime input[type="radio"]`);
            if (radioInput) {
                radioInput.checked = true;
            }*/

            document.querySelectorAll(`#hwsubsplanlist li input[type="radio"]`).forEach(radio => {
                radio.checked = false;
            });


            document.querySelectorAll(".hwplanfrqdreopdown, .Hw-subs-description span, .Hw-subs-description").forEach(el => el.style.display = "none");

            document.querySelectorAll(".subsoptionsforsel").forEach((el) => {
                el.checked = false;
            });

            if (selectedBatch) {
                setTimeout(function() {
                    let defaultClickElement = selectedBatch.querySelector(".clickbydefault");
                    if (defaultClickElement) {
                        defaultClickElement.click();
                        /*document.querySelectorAll(".batchblocks").forEach(el => {
                            el.style.display = "block";
                        });*/
                    }
                },300);
            }
        });
        document.querySelectorAll(".Hw-subs-qty-box-main").forEach(function (box) {
            let minusBtn = box.querySelector(".Hw-subs-qty-minus");
            let plusBtn = box.querySelector(".Hw-subs-qty-plus");
            let inputField = box.querySelector(".Hw-subs-qty-input");

            // --- Decrease quantity ---
            minusBtn.addEventListener("click", function () {
                let currentValue = parseInt(inputField.value) || 1;
                if (currentValue > 1) {
                    inputField.value = currentValue - 1;
                    handleQuantityChange(inputField.value, inputField); // 👈 run on minus click
                }
            });

            // --- Increase quantity ---
            plusBtn.addEventListener("click", function () {
                let currentValue = parseInt(inputField.value) || 1;
                inputField.value = currentValue + 1;
                handleQuantityChange(inputField.value, inputField); // 👈 run on plus click
            });

            // --- Manual typing ---
            inputField.addEventListener("input", function () {
                let currentValue = parseInt(inputField.value) || 1;
                if (currentValue < 1) {
                    inputField.value = 1;
                }
                handleQuantityChange(inputField.value, inputField); // 👈 run on manual typing
            });
        });
}
